export default __webpack_public_path__ + "static/media/p1.a681b3ff.png";